//===============about helper============
export const progressBarData = [
  {
    id: 1,
    icon: '/assets/images/about-us/reliability.png',
    label: 'reliability',
    value: '52',
    fillColor: '#F89B55',
  },
  {
    id: 2,
    icon: '/assets/images/about-us/clock.png',
    label: 'Timely Execution',
    value: '21',
  },
  {
    id: 3,
    icon: '/assets/images/about-us/excelence.png',
    label: 'Excellence',
    value: '74',
  },
  {
    id: 4,
    icon: '/assets/images/about-us/memEvent.png',
    label: 'Memorable Events',
    value: '74',
  },
];
